import React from 'react'
import Login from '../Components/Login/Login'
function LoginAcc() {
  return (
    <div>
        <Login/>
    </div>
  )
}

export default LoginAcc